import { render } from "./WebFiltering.vue?vue&type=template&id=2992c438"
import script from "./WebFiltering.vue?vue&type=script&lang=js"
export * from "./WebFiltering.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__